/*
 * � 2020 Microsoft. All rights reserved.
 */

define('MenuUI/ChallengeTile',[
	'pixi',
	'absolute',
	'lodash',
	'Solitaire/SolitaireGameMode',
	'MenuUI/MenuTile',
	'Managers/TelemetryManager'
],

	function (PIXI, Absolute, _, SolitaireGameMode, MenuTile, TelemetryManager) {

		var ChallengeTile = function (config, challenge, date, challengeMenu) {
			var defaultConfig = {
				imageScale: 2,
				letterStyle: {
					font: '' + config.scaleText * 32 + "px Arial",
					fontFamily: 'segoeLight',
					fill: '#ffffff',
					align: 'left'
				}
			};
			this.initChallengeTile(_.extend(defaultConfig, config), challenge, date, challengeMenu);
		};

		ChallengeTile.prototype = Object.create(MenuTile.prototype);

		ChallengeTile.prototype.initChallengeTile = function (config, challenge, date, challengeMenu) {

			this.challengeMenu = challengeMenu;
			this.challenge = challenge;
			this.date = date;

			MenuTile.call(this, config);

			this.label.x = (this.width - this.label.width) / 2;

			var horizontalLine = new PIXI.Graphics(),
				horizontalLineWidth = Absolute.Coords.x(config.width * 2 / 3),
				horizontalLineWeight = Absolute.Coords.x(config.width / 84),
				descriptionStyle = {
					font: (config.scaleText - config.scaleText/5) * 30 + 'px Arial',
					fontFamily: 'segoe',
					fill: '#ffffff',
					tint: 0xffffff,
					align: 'center'
				},
				description = new PIXI.Text(this.challenge.ShortGoalDescription, descriptionStyle),
				difficultyBar = new PIXI.Graphics(),
				difficultyStyle = {
					font: (config.scaleText - config.scaleText/5) * 32 + 'px Arial',
					fontFamily: 'segoe',
					fill: '#ffffff',
					tint: 0xffffff,
					align: 'center'
				},
				difficultyStrings = Absolute.StringManager('difficulty', null, true),
				difficultyText = new PIXI.Text(difficultyStrings[this.challenge.Difficulty - 1], difficultyStyle);
			difficultyText.position.set(Absolute.Coords.x(10), Absolute.Coords.y(config.scaleText * 42 / 2)+4);
			difficultyText.anchor.set(0, .5);

			horizontalLine.moveTo(0, 0);
			horizontalLine.lineStyle(horizontalLineWeight, 0xffffff, 1);
			horizontalLine.lineTo(horizontalLineWidth, 0);
			horizontalLine.x = (this.width - horizontalLineWidth) / 2;
			horizontalLine.y = Absolute.Coords.y(360);
			this.addChild(horizontalLine);

			Absolute.StringManager.shrinkToFit(description, 25, '', this.width - Absolute.Coords.x(20))
			description.x = (this.width - description.width) / 2;
			description.y = Absolute.Coords.y(375);

			this.addChild(description);

			if (this.challenge.Completed) {
				this.complete = true;
				var completeRibbon = PIXI.Sprite.fromFrame('dailychallenge/ribbon_DC.png');
				completeRibbon.x = (this.width - completeRibbon.width) / 2;
				completeRibbon.y = Absolute.Coords.y(107);
				this.addChild(completeRibbon);
			}

			difficultyBar.beginFill(0x000000, 0.7);
			difficultyBar.drawRect(0, 0, this.width, Absolute.Coords.y(config.scaleText * 46));
			difficultyBar.endFill();
			this.addChild(difficultyBar);

			this.addChild(difficultyText);
			var difficultyStars = [];
			_.times(this.challenge.Difficulty, function (count) {
				var difficultyStar = PIXI.Sprite.fromFrame('dailychallenge/challenge_diff_star.png');
				difficultyStar.scale.x = difficultyStar.scale.y = config.scaleText;
				// difficultyStar.x = this.width - difficultyStar.width - Absolute.Coords.x(10) - count * (difficultyStar.width + Absolute.Coords.x(5));
				// difficultyStar.y = Absolute.Coords.y(5);
				difficultyStar.position.set(
					this.width - difficultyStar.width - Absolute.Coords.x(10) - count * (difficultyStar.width + Absolute.Coords.x(5)),
					Absolute.Coords.y(config.scaleText * 42 / 2));
				difficultyStar.anchor.set(0, .5);
				this.addChild(difficultyStar);
				difficultyStars.push(difficultyStar);
			}, this);
			Absolute.StringManager.shrinkToFit(difficultyText,
				Absolute.ScreenMetrics.getResScale() * 28, '',
				this.width - (difficultyStars.length * difficultyStars[0].width) - Absolute.Coords.x(30));

			this.interactive = true;

		};

		ChallengeTile.prototype.handleClick = function () {
			//this.challengeMenu.startGame(SolitaireGameMode[this.config.mode]);
			var formattedDate = (this.date.getMonth() + 1) + '/' + this.date.getDate() + '/' + this.date.getFullYear();
			this.challengeMenu.game.startGame(SolitaireGameMode[this.config.mode], this.challenge);
		};

		ChallengeTile.prototype.onShow = function () {
			if (this.complete !== this.challenge.Completed && this.challenge.Completed) {

				this.complete = this.challenge.Completed;

				this.addRibbon(function () {
					this.challengeMenu.onChallengeCompleted(this)
					this.interactive = true;
				}.bind(this));

			} else {
				this.interactive = true;
			}


		};

		ChallengeTile.prototype.onHide = function () {
			if (this.completeRibbon) {
				this.completeRibbon.alpha = 1;
				this.completeRibbon.scale.x = this.completeRibbon.scale.y = 1;
			}
			if (this.ribbonTween) {
				this.ribbonTween.stop();
			}
			this.interactive = false;
			this.hover.visible = false;
		};

		ChallengeTile.prototype.addRibbon = function (callback) {

			var startingScale = 3,
				self = this;

			if (!this.completeRibbon) {
				this.completeRibbon = PIXI.Sprite.fromFrame('dailychallenge/ribbon_DC.png');
				this.completeRibbon.anchor.x = this.completeRibbon.anchor.y = 0.5;
				this.completeRibbon.x = this.width / 2;
				this.completeRibbon.y = Absolute.Coords.y(200);
				this.addChildAt(this.completeRibbon, this.children.length - 1);
			}

			window.setTimeout(function () {
				Absolute.AudioManager.playSound('dc_ribbonHit');
				Absolute.AudioManager.playSound('dc_coinsToBar');
			}, 800);

			this.ribbonTween = new TWEEN.Tween({ scale: startingScale, alpha: 0 })
				.easing(TWEEN.Easing.Cubic.In)
				.to({ scale: 1, alpha: 1 }, 1000)
				.onStart(function () {
					self.completeRibbon.scale.x = self.completeRibbon.scale.y = startingScale;
					self.completeRibbon.alpha = 0;
				})
				.onUpdate(function () {
					self.completeRibbon.scale.x = self.completeRibbon.scale.y = this.scale;
					self.completeRibbon.alpha = this.alpha;
				})
				.onComplete(function () {

					window.setTimeout(function () {
						callback();
					}, 200);
				})
				.start();
		};


		return ChallengeTile;

	});

